import React from 'react';
import {Button} from 'antd';
import {Tag} from 'antd';
import {formatDateThirtyDaysLater} from '../../utils/DateFunctions';
import {hasProfessionalAccount, hasProfessionalAccountAndIsInCancellationState} from '../../utils/variables/userVariables';

export const SUBSCRIPTION_TYPES = {
	free: 'free',
	basic: 'basic',
	premium: 'premium',
	premiumArchived: 'premium_archived',
	premium_plus: 'premium_plus',
};

export function price_for_plan(record: any, user: any = null): string | React.ReactNode {
	const subscription_type = record?.subscription_type;

	if (hasProfessionalAccount(user)) {
		return <Tag color="green">Included in Professional Account</Tag>;
	}

	switch (subscription_type) {
		case SUBSCRIPTION_TYPES.free:
			return 'Free';
		case SUBSCRIPTION_TYPES.basic:
			return '$59 USD (once off)';
		case SUBSCRIPTION_TYPES.premium:
			return '$79 USD (once off)';
		case SUBSCRIPTION_TYPES.premiumArchived:
			return '$45 USD/month (Archived)';
		case SUBSCRIPTION_TYPES.premium_plus:
			return '$20 USD/month';
		default:
			return 'Unknown';
	}
}

export function subscription_text(record: any): string {
	const subscription_type = record?.subscription_type;

	switch (subscription_type) {
		case SUBSCRIPTION_TYPES.free:
			return 'Free';
		case SUBSCRIPTION_TYPES.basic:
			return 'Basic';
		case SUBSCRIPTION_TYPES.premium:
			return 'Premium';
		case SUBSCRIPTION_TYPES.premium_plus:
			return 'Premium Plus (Old)';
		default:
			return 'Unknown';
	}
}

interface Record {
	id: string;
	stripe_subscription: string | null;
	stripe_in_cancellation_state: boolean;
	subscription_type: string;
	created_with_account_subscription: boolean;
}

export const renderSubscriptionButton = (record: Record, showCase: any) => {
	if (record.subscription_type === 'free') {
		return null;
	}

	if (record.stripe_subscription !== null) {
		return (
			<Button onClick={() => showCase(record.id, false)} disabled={record.stripe_in_cancellation_state} danger={!record.stripe_in_cancellation_state}>
				Cancel subscription
			</Button>
		);
	} else {
		return !record?.created_with_account_subscription ? (
			<Button onClick={() => showCase(record.id, true)} type="primary">
				Activate subscription
			</Button>
		) : (
			'Part of Account Subscription'
		);
	}
};

export const renderSubscriptionStatusTag = (record: any, user: any = null) => {
	if (record.subscription_type === 'free') {
		return (
			<div className="flex items-center flex-col">
				<Tag color="blue" className="mx-auto">
					Free
				</Tag>
			</div>
		);
	}
	return !record?.completed ? (
		<div className="flex items-center flex-col gap-2">
			<Tag color="green">Active</Tag>
			{record.stripe_in_cancellation_state && <span className="text-xs text-center">In cancellation period until {formatDateThirtyDaysLater(record.stripe_subscription_date)}</span>}
			{hasProfessionalAccountAndIsInCancellationState(user) && (
				<span className="text-xs text-center">In cancellation period until {formatDateThirtyDaysLater(user?.account_subscription_date)}</span>
			)}
		</div>
	) : (
		<div className="flex items-center flex-col gap-2">
			<Tag color="volcano">Inactive</Tag>
		</div>
	);
};
